import { render, staticRenderFns } from "./collections.vue?vue&type=template&id=6d4a3377&scoped=true&"
import script from "./collections.vue?vue&type=script&lang=js&"
export * from "./collections.vue?vue&type=script&lang=js&"
import style0 from "./collections.vue?vue&type=style&index=0&id=6d4a3377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a3377",
  null
  
)

export default component.exports